// Kalender: To-dos mit Tag, Deadlines aus den Live-Tabellen und Termine aus Microsoft 365

/** To-do eines Kunden mit Tag (optional von–bis) */
export interface CalTodo {
  id: string;
  clientId: string;
  text: string;
  done: boolean;
  /** YYYY-MM-DD */
  day: string;
  /** HH:MM */
  from: string | null;
  to: string | null;
  project: string | null;
}

/** Video aus einer Live-Tabelle mit Deadline */
export interface CalDeadline {
  clientId: string;
  /** Wiedererkennung wie in der Live-Tabelle (Abschnitt|Video) */
  key: string;
  video: string;
  section: string;
  stand: string;
  /** wer dran ist */
  todo: string;
  /** YYYY-MM-DD */
  due: string;
  /** bei mir oder bei niemand Bestimmtem */
  mine: boolean;
  done: boolean;
}

/** Termin aus Exchange (wird nur angezeigt, nie gespeichert) */
export interface CalEvent {
  id: string;
  subject: string;
  /** YYYY-MM-DD (ganztägig) oder YYYY-MM-DDTHH:MM */
  start: string;
  end: string;
  allDay: boolean;
  location: string;
  /** Name des Kalenders in Exchange */
  calendar: string;
  calendarId: string;
  /** darf im Tool geändert werden (eigener Kalender, nicht z. B. Geburtstage) */
  editable: boolean;
  webLink: string;
}

/** Termin, wie das Tool ihn in Exchange anlegt oder ändert */
export interface EventDraft {
  subject: string;
  location: string;
  /** YYYY-MM-DD */
  day: string;
  /** HH:MM; ohne: ganzer Tag */
  from: string | null;
  to: string | null;
  /** ohne: der verbundene Kalender (z. B. «Kunden Termine») */
  calendarId?: string;
}

export interface MsCalendar {
  id: string;
  name: string;
  canEdit: boolean;
}

export interface MsStatus {
  /** App-Registrierung eingetragen */
  configured: boolean;
  tenantId: string;
  clientId: string;
  /** mit einem Microsoft-Konto angemeldet */
  connected: boolean;
  account: string;
  /** Kalender, in den To-dos und Deadlines geschrieben werden */
  calendarId: string;
  calendarName: string;
  /** weitere Kalender, deren Termine im Tool erscheinen */
  showIds: string[];
  lastSync: string | null;
  error: string | null;
  /** diese Adresse muss in der App-Registrierung als Umleitungs-URI stehen */
  redirectUri: string;
}

export interface CalendarResponse {
  from: string;
  to: string;
  todos: CalTodo[];
  deadlines: CalDeadline[];
  events: CalEvent[];
  ms: MsStatus;
}

/** Tag in der Schweiz (YYYY-MM-DD), auch wenn der Server in UTC läuft */
export const zurichDay = (d: Date = new Date()) => new Intl.DateTimeFormat("sv-SE", { timeZone: "Europe/Zurich", year: "numeric", month: "2-digit", day: "2-digit" }).format(d);

/** YYYY-MM-DD plus n Tage */
export const addDays = (day: string, n: number) => {
  const d = new Date(`${day}T12:00:00Z`);
  d.setUTCDate(d.getUTCDate() + n);
  return d.toISOString().slice(0, 10);
};
